<div class="toolbox-edit-dialog-container">
  <p class="title">Edit Query Type</p>
  <form [formGroup]="editItemForm" class="toolbox-form" (ngSubmit)="submit()">
    <mat-form-field>
      <mat-label>Query Name</mat-label>
      <textarea
        formControlName="text"
        matInput
        matTextareaAutosize
        matAutosizeMinRows="1"
        matAutosizeMaxRows="2"
        placeholder=""
        [value]="data.itemText"
        ></textarea>
    </mat-form-field>
    <arb-message class="message" [message$]="error$"></arb-message>
    <br>
    <div class="buttons">
      <button mat-flat-button color="secondary" (click)="close(false)">Cancel</button>
      <button mat-flat-button color="primary" (click)="submit()" [disabled]="!editItemForm.valid">Update</button>
    </div>
  </form>
</div>